import { Link } from "react-router-dom";
import StatusIndicator from "../Shared/StatusIndicator";
import { COLOUR } from "../../config/constants";

const DataTable = ({ clients }) => {
  return (
    <div className="mt-8 flow-root">
      <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
          <div className="overflow-hidden bg-white border border-ink-100 shadow-hairline sm:rounded-card">
            <table className="min-w-full">
              <thead className="border-b border-ink-100">
                <tr>
                  <th
                    scope="col"
                    className="py-3 pl-4 pr-3 text-left smallcaps text-ink-400 sm:pl-6"
                  >
                    Name
                  </th>
                  <th
                    scope="col"
                    className="hidden px-3 py-3 text-left smallcaps text-ink-400 lg:table-cell"
                  >
                    Email
                  </th>
                  <th
                    scope="col"
                    className="hidden px-3 py-3 text-left smallcaps text-ink-400 sm:table-cell"
                  >
                    Phone Number
                  </th>
                  <th
                    scope="col"
                    className="hidden px-3 py-3 text-left smallcaps text-ink-400 sm:table-cell"
                  >
                    Address
                  </th>
                  <th scope="col" className="relative py-3.5 pl-3 pr-4 sm:pr-6">
                    <span className="sr-only">Edit</span>
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-ink-100 bg-white">
                {clients.map((client) => (
                  <tr key={client._id} className="hover:bg-cream-100 transition-colors">
                    <td className="w-full max-w-0 py-4 pl-4 pr-3 text-sm font-medium text-ink-900 sm:w-auto sm:max-w-none sm:pl-6">
                      <div className="flex items-center gap-2">
                        <span>{client.fullName}</span>
                        {client.archived && (
                          <StatusIndicator colour={COLOUR.GRAY} label="Archived" />
                        )}
                      </div>
                      <dl className="font-normal lg:hidden">
                        <dt className="sr-only">Email</dt>
                        <dd className="mt-1 truncate text-ink-700">
                          {client.email}
                        </dd>
                        <dt className="sr-only sm:hidden">Phone Number</dt>
                        <dd className="mt-1 truncate text-ink-500 sm:hidden">
                          {client.phoneNumber}
                        </dd>
                        <dt className="sr-only sm:hidden">Address</dt>
                        <dd className="mt-1 truncate text-ink-500 sm:hidden">
                          {client.serviceAddress?.full}
                        </dd>
                      </dl>
                    </td>
                    <td className="hidden px-3 py-4 text-sm text-ink-500 lg:table-cell">
                      {client.email}
                    </td>
                    <td className="hidden px-3 py-4 text-sm text-ink-500 sm:table-cell">
                      {client.phoneNumber}
                    </td>
                    <td className="hidden px-3 py-4 text-sm text-ink-500 sm:table-cell">
                      {client.serviceAddress?.full}
                    </td>
                    <td className="py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6 ">
                      <Link
                        to={`${client._id}`}
                        className="text-accent-600 hover:text-accent-500"
                      >
                        View
                        <span className="sr-only">{client.fullName}</span>
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DataTable;
